import React from "react";
import { withTranslation } from "react-i18next";
import { Grid } from "semantic-ui-react";

import { round2, getInterventionTotals, calculateVatGroups } from "../../../../../../util/common";

const TotalAmount = ({ communication, kiosk, t }) => {
  const { include_vat, vat } = kiosk;
  const { interventions } = communication.appointment;
  const { check_in_results: optional_services } = communication;

  const interventionTotals = getInterventionTotals(interventions, kiosk);

  let servicesTotalPrice = 0;
  let additionalPrices = 0;
  const vatRate = include_vat ? 1 + vat / 100 : 1;

  if (Array.isArray(optional_services)) {
    servicesTotalPrice = optional_services.reduce((prev, cur) => {
      if (cur.accepted && cur.price > 0.01) {
        prev += round2(cur.price * vatRate);
        additionalPrices += cur.price;
      }
      return prev;
    }, 0);
  }

  const totalAmount = round2(interventionTotals.totalAmount + servicesTotalPrice);
  if (!totalAmount) return null;

  const allVatGroups = calculateVatGroups(interventionTotals.vatGroups, additionalPrices, kiosk);
  const vatGroups = allVatGroups.filter(vatGroup => vatGroup.rate > 0 && vatGroup.amount > 0);

  return (
    <Grid className="OrderContainer TotalAmount">
      {include_vat &&
        allVatGroups.length > 1 &&
        vatGroups.map(vatGroup => (
          <Grid.Row key={"total-" + vatGroup.rate}>
            <Grid.Column width={14}>
              <span className="vat-name">
                {t("cc_total_with").message || "Total with"} {vatGroup.rate}% {t("cc_vat").message || "VAT"}
              </span>
            </Grid.Column>
            <Grid.Column width={2}>
              <span className="price">€ {vatGroup.total.toFixed(2)}</span>
            </Grid.Column>
          </Grid.Row>
        ))}
      <Grid.Row>
        <Grid.Column width={14}>
          <span className="name">{t("cc_TOTAL_AMOUNT").message || "TOTAL AMOUNT"}:</span>
        </Grid.Column>

        <Grid.Column width={2}>
          <span className="price">€ {totalAmount.toFixed(2)}</span>
        </Grid.Column>
      </Grid.Row>
      {include_vat &&
        vatGroups.map(vatGroup => (
          <Grid.Row key={vatGroup.rate}>
            <Grid.Column width={14}>
              <span className="vat-name">
                *{t("cc_including").message || "Including"} {vatGroup.rate}% {t("cc_vat").message || "VAT"}
              </span>
            </Grid.Column>

            <Grid.Column width={2}>
              <span className="price">€ {vatGroup.amount.toFixed(2)}</span>
            </Grid.Column>
          </Grid.Row>
        ))}
    </Grid>
  );
};

export default withTranslation()(TotalAmount);
